import ListClient from "./listClient.js";
import CreateClient from "./createClient.js";
import EditClient from "./editClient.js";
import ShowClient from "./showClient.js";

export default { ListClient, CreateClient, EditClient, ShowClient };
